import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const fetchClientNetworkFeatures = async () => {
    const response = await apiFetch(`${API_BASE}/networks/client/features`);
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося завантажити модулі мережі");
    }
    return response.json();
};
